module.exports = __webpack_public_path__ + "img/icon-config.2c0e3392.png";